module.exports = "/settings/components/shiftAlarms/shiftAlarmsComponent-2bbca2.html";